import { UAParser } from "ua-parser-js";
//export const supportedBrowsers = ["Chrome", "Firefox", "Safari", "Chrome WebView", "Mobile Safari", "Edge"];
export const supportedBrowsers = ["Chrome", "Firefox", "Safari", "Chrome WebView", "Mobile Safari"];
let parser = new UAParser();
export function GetBrowser() {
    return parser.getBrowser();
}
/*export function GetBrowserName(): BrowserName {
    return parser.getBrowser().name;
}
export function GetBrowserVersion(): string {
    return parser.getBrowser().version;
}*/ 
